import React from 'react';
import theme from './CreateCommentThreadModalFollowerSelect.module.scss';
import { PossibleChatFollower, SimplifiedBuyerUser } from '@/types';
import Select, { components } from 'react-select';
import { UserIcon, ProfileIcon } from '@/components/Icons';
import { classnames } from '@/utils/html';
import { t } from '@lingui/core/macro';

const Option = (props) => {
    const data: PossibleChatFollower = props.data;
    return (
        <components.Option {...props}>
            <div className={theme.optionContainer}>
                <div className={theme.images}>
                    <ProfileIcon sizeInPx={36} profileId={data.profileId} />
                    <UserIcon className={theme.userIcon} sizeInPx={24} userId={data.applicationUserId} />
                </div>
                <div className={theme.textSection}>
                    <div className={theme.name}>{data.name}</div>
                    <div className={theme.profileName}>{data.profileName}</div>
                </div>
            </div>
        </components.Option>
    );
};

const MultiValueLabel = (props) => {
    const data: PossibleChatFollower = props.data;
    return (
        <div key={props.data.value} className={classnames(theme.selectedOption, { [theme.isBuyer]: props.data.isFixed })}>
            <UserIcon className={theme.userIcon} sizeInPx={20} userId={data.applicationUserId} />
            <components.MultiValueLabel {...props} />
        </div>
    );
};

const styles = {
    multiValueRemove: (base, state) => {
        return state.data.isFixed ? { ...base, display: 'none' } : base;
    },
};

interface CreateCommentThreadModalFollowerSelectProps {
    users: PossibleChatFollower[];
    value: number[];
    onChange(selectedUnits: number[]): void;
    buyers: SimplifiedBuyerUser[];
}

const CreateCommentThreadModalFollowerSelect: React.FC<CreateCommentThreadModalFollowerSelectProps> = ({
    users,
    value,
    onChange,
    buyers,
}) => {
    const fixedOptions = users.map((u) => ({ value: u.projectMemberId, label: u.name, ...u }));
    const fixedValue = fixedOptions.filter((u) => value.some((v) => +v === u.projectMemberId));

    const fixedBuyers: Partial<PossibleChatFollower>[] = buyers.map((b) => ({
        applicationUserId: b.userId!,
        name: b.displayName,
        label: b.displayName,
        value: b.userId,
        email: b.email,
        isFixed: true,
    }));

    const handleChange = (newValue, actionMetaData) => {
        if (!newValue || !Array.isArray(newValue)) {
            onChange([]);
        } else {
            onChange(newValue.filter((nw) => !nw.isFixed).map((nw) => nw.value));
        }
    };
    return (
        <Select
            styles={styles}
            classNamePrefix="r-s"
            className="react-select full-width"
            // filterOption={filterOption}
            placeholder={t`Who should be a follower of this thread`}
            onChange={handleChange}
            isMulti
            value={fixedBuyers.concat(fixedValue)}
            isClearable={fixedValue.length > 0}
            options={fixedOptions}
            components={{ Option, MultiValueLabel }}
        />
    );
};

export default CreateCommentThreadModalFollowerSelect;